import { Component, OnInit } from '@angular/core';
import { PayeeApi } from '../shared/sdk/services';
import { RequestAssistanceApi } from '../shared/sdk/services';
import { ServiceApi } from '../shared/sdk/services';
import { LoopBackConfig } from '../shared/sdk/lb.config';
import { GlobalEventsManager } from '../events-manager.component';
import { AuthGuard } from '../shared/auth.guard';
import { Payee, AccessToken } from '../shared/sdk/models';
import { Router } from '@angular/router';
import { CONSTANT } from '../shared/app/constants'
import { HttpClient,HttpHeaders } from  "@angular/common/http";
import { DomSanitizer } from '@angular/platform-browser';
import  $ from 'jquery';
import { CookieService } from 'ngx-cookie-service';

@Component({
  selector: 'home',
  templateUrl: 'home.component.html',
  styleUrls: ['home/style.css']
})

export class HomeComponent implements OnInit {

  // public user: CustomUser;
  // public name: string;
  contact;
  services = [];
  servicesObj;
  authenticated: boolean;
  selectedService = -1;
  contactUsStr = "Get in touch with us!";
  SERVICE_DESC = CONSTANT.SERVICE_DESC;

  captcha;
  valid = true;
  constructor(
    private eventsManager: GlobalEventsManager,
    private userApi: PayeeApi,
    private serviceApi: ServiceApi,
    private requestAssistanceApi: RequestAssistanceApi,
    private router: Router,
    private http:HttpClient,
    private sanitizer:DomSanitizer,
    private authGuard: AuthGuard,
    private cookieService: CookieService)
  { 
    // Reload script.js
    
    // $.getScript('../../js/mimity.js');

    this.eventsManager.showNavBarEmitter.subscribe((mode)=>{
          // mode will be null the first time it is created, so you need to igonore it when null
          if (mode !== null) {
            this.authenticated = mode;
          } else {
            this.authenticated = this.authGuard.authenticated();
          }
      });

    this.serviceApi.find({fields:{id:true, name:true, group:true, sequence:true}, order:'sequence ASC'}).subscribe(
      res => {
        console.log(res);
        if(res!=null || typeof res != 'undefined'){
          this.servicesObj = res;
          for (var i in res){ 
            this.services.push(res[i]['name']);
          }
        }
        //console.log(this.services);
      }, 
      err => {
        console.log(err);
      }
    );
  }
  ngOnInit() { 
    window.scrollTo(0, 0)
    this.eventsManager.loaded(true);
    
    this.contact ={
      'name':null,
      'from_email':null,
      'service':null,
      'service_grp':null,
      'message':null,
      'captcha':null

    }
    // Reload script.js
    let script2 = document.createElement('script');
    script2.type = 'text/javascript';
    script2.src = 'js/script.js';
    script2.onload = () => {
        console.log('SCRIPT LOAD');
    };           
    script2.onerror = () => console.log('SCRIPT ERROR'); 
    document.getElementsByTagName('head')[0].appendChild(script2);

    let script = document.createElement('script');
    script.type = 'text/javascript';
    script.src = 'js/active.js';
    script.onload = () => {
        console.log('SCRIPT LOAD active');
    };           
    script.onerror = () => console.log('SCRIPT ERROR'); 
    document.getElementsByTagName('head')[0].appendChild(script);

    // change true: if services chosen, display home page else reroute to application
    // this.userApi.countSubmissions(this.userApi.getCurrentId(), {'isSubmitted': true}).subscribe(
    //   (res) => {
    //     if (res.count > 0) {
    //       this.router.navigate(['/dashboard']);
    //     } else {
    //       this.router.navigate(['/chooseServices']);
    //     }
    //   },
    //   () => this.router.navigate(['/chooseServices'])
    // );
    this.getCaptcha();
  }

  ngAfterViewInit(){
    //console.log("cookie"); console.log(this.cookieService.check("SessionCookie"));
    let today = new Date();
    let limitDate = new Date('2019-03-01')
    if (limitDate > today) {
      if(!this.cookieService.check("NoticeCookie")){
        this.eventsManager.showPopUp("<b>IMPORTANT NOTICE</b><br><br>The New Maybank2u Pay Website - Web Redirection Announcement<br><br>Dear Valued Customers,<br><br>Please be informed that starting February 2019, you will be automatically redirected to the new version of Maybank2u Pay when you access ‘www.m2upay.maybank2u.com.my’ from your browser.<br><br>We have added a suite of Cards Payment Services to the Maybank2u Pay family.<br>Find out more about the <a href=\"/assets/faq/index.html\" style=\"color: rgb(0,0,255)\"><b>newly added services here</b></a>.");
        

        this.cookieService.set("NoticeCookie",today.getFullYear()+"-"+(today.getMonth()+1)+"-"+today.getDate(),1);
      }
    }
    

    //this.cookieService.delete("NoticeCookie");
  }

  getCaptcha(){
    let _url: string = LoopBackConfig.getPath() + "/" + LoopBackConfig.getApiVersion() +"/captchas/simpleEnqImg?time=" 
    this.http
      .get(_url+(new Date().getTime() / 1000), {responseType: 'text',withCredentials: true})
        .subscribe(
          data => {
            this.captcha = this.sanitizer.bypassSecurityTrustHtml(data.toString());
            // console.log({data})
          }, 
          error => {
            // console.log({error})
          }
        );
  }
  onServicesChange(){
    this.contact.service_grp = [this.servicesObj[this.selectedService]['group']]; console.log (this.contact.service_grp);
    this.contact.service = [this.servicesObj[this.selectedService]['id']]; console.log (this.contact.service);
  }

  validate(){

    if (this.contact.name && this.contact.from_email && this.contact.service && this.contact.message&& this.contact.bot) {
      return true
    }
    else
      return false
  }

  onFormSubmit(value){
    this.valid = this.validate();
    console.log(this.contact);
    LoopBackConfig.setRequestOptionsCredentials(true);
    if (this.valid ){
      this.requestAssistanceApi.create(this.contact).subscribe(
      res => {
        this.getCaptcha();
        LoopBackConfig.setRequestOptionsCredentials(false);
        console.log("RA - Response");
        console.log(res);
        this.eventsManager.showPopUp("Thank you for your enquiry. We have sent you a confirmation email.");
      }, 
      err => {
        this.getCaptcha();
        LoopBackConfig.setRequestOptionsCredentials(false);
        if(err){
           console.log(err);
           if (err.code =="CAPTCHA_FAILED") {
             this.eventsManager.showPopUp(err.message);
           }
           else
            this.eventsManager.showPopUp("Something went wrong. Please try again later.");
        }
      }
      );
    }

  }

}
